import React from 'react'
import IconButton from './IconButton'
import EditorModeEdit from 'material-ui-legacy/svg-icons/editor/mode-edit'

const EditButton = ({ icon, label, ...restProps }) => (
  <IconButton
    label={label || 'Edit'}
    icon={icon || <EditorModeEdit />}
    {...restProps}
  />
)

export default EditButton



// WEBPACK FOOTER //
// ./src/components/UI/EditButton.jsx